import Reg from "../../common/Reg";

export class CodeForm {
  phone = "";
  platform = "pc";
  source = "";
}

export class MobileLoginForm {
  phone = "";
  password = "";
}

export class EmailLoginForm {
  email = "";
  password = "";
}

export default class LoginFrom {
  mobile = "";
  phone = "";
  captcha = "";
  platform = "pc";

  public rules(): { [key: string]: object[] } {
    return {
      phone: [
        { required: true, message: "请输入手机号", trigger: "blur" },
        {
          validator: (rule: unknown, value: string, callback: Function) => {
            if (!Reg.isMobile(value)) {
              return callback(new Error("手机号格式校验失败"));
            } else {
              return callback();
            }
          },
          trigger: ["blur"]
        }
      ],
      captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }]
    };
  }
}
